import type { TDividerElement } from '@shared/dream-components';
import { DividerElement } from '@shared/dream-components';
import type { ReactNode } from 'react';

interface Props {
  node: TDividerElement;
  children: ReactNode | ReactNode[];
}

const Divider = ({ node, children }: Props) => {
  return <DividerElement element={node}>{children}</DividerElement>;
};

export default Divider;
